export type Alias = { name: string; altName: string };

/** Explicit conversion direction: source articulation name -> destination name. */
export type ArticulationAliases = Record<string, string>;

export const GTP_ALIASES: Alias[] = [
  { name: "Crash medium (choke)", altName: "Crash medium (hit)" },
  { name: "Hi-Hat (open 2)", altName: "Hi-Hat (open)" },
  { name: "Hi-Hat (open 3)", altName: "Hi-Hat (open)" },
  { name: "Hi-Hat (half 2)", altName: "Hi-Hat (half)" },
  { name: "Hi-Hat (half 3)", altName: "Hi-Hat (half)" },
  { name: "Hi-Hat (closed 2)", altName: "Hi-Hat (closed)" },
  { name: "Mini Ride Bell 1", altName: "Ride (bell)" },
  { name: "Mini Ride Bell 2", altName: "Ride (bell)" },
  { name: "Ride (bell 2)", altName: "Ride (bell)" },
  { name: "Ride (hit)", altName: "Ride (edge)" },
  { name: "Double Stack", altName: "Ride (choke)" },
  { name: "Stick", altName: "Snare (side stick)" },
  { name: "Snare (hit 2)", altName: "Snare (rim shot)" },
  { name: "Kick", altName: "Kick (hit)" },
  { name: "Snare - Hit - Centre", altName: "Snare (hit)" },
  { name: "Snare - Cross Stick", altName: "Snare (side stick)" },
  { name: "Hats - Tight Tip", altName: "Hi-Hat (closed)" },
  { name: "Hats - Tight Edge", altName: "Hi-Hat (half)" },
  { name: "Hats - Closed Tip", altName: "Hi-Hat (closed)" },
  { name: "Hats - Closed Edge", altName: "Hi-Hat (closed)" },
  { name: "Hats - Open 1", altName: "Hi-Hat (open)" },
  { name: "Hats - Open 2", altName: "Hi-Hat (open)" },
  { name: "Hats - Open 3", altName: "Hi-Hat (open)" },
  { name: "Hats - Pedal Chick", altName: "Pedal Hi-Hat (hit)" },
  { name: "Rack Tom 1 - Hit", altName: "High Tom (hit)" },
  { name: "Floor Tom 1 - Hit", altName: "Low Tom (hit)" },
  { name: "Floor Tom 2 - Hit", altName: "Very Low Tom (hit)" },
  { name: "Crash 1 (Far Left) - Crash", altName: "Crash high (hit)" },
  { name: "Crash 1 (Far Left) - Choke", altName: "Crash high (choke)" },
  { name: "Crash 2 (Left) - Crash", altName: "Crash medium (hit)" },
  { name: "Ride - Bow", altName: "Ride (edge)" },
  { name: "Ride - Bell", altName: "Ride (bell)" },
  { name: "Ride - Choke", altName: "Ride (choke)" },
  { name: "China - Crash", altName: "China (hit)" },
  { name: "China - Choke", altName: "China (choke)" },
  { name: "Splash - Crash", altName: "Splash (hit)" },
  { name: "Splash - Choke", altName: "Splash (choke)" },
];

/** GTP articulation names accepted by the canonical P5 map. */
export const GGD_P5_ALIASES: Alias[] = [
  { name: "Kick (hit)", altName: "Kick" },
  { name: "Snare (hit)", altName: "Snare - Hit - Centre" },
  { name: "Snare (side stick)", altName: "Snare - Cross Stick" },
  { name: "Hi-Hat (closed)", altName: "Hats - Closed Tip" },
  { name: "Hi-Hat (half)", altName: "Hats - Tight Edge" },
  { name: "Hi-Hat (open)", altName: "Hats - Open 1" },
  { name: "Pedal Hi-Hat (hit)", altName: "Hats - Pedal Chick" },
  { name: "High Tom (hit)", altName: "Rack Tom 1 - Hit" },
  { name: "High Floor Tom (hit)", altName: "Rack Tom 1 - Hit" },
  { name: "Mid Tom (hit)", altName: "Floor Tom 1 - Hit" },
  { name: "Low Tom (hit)", altName: "Floor Tom 1 - Hit" },
  { name: "Low Floor Tom (hit)", altName: "Floor Tom 1 - Hit" },
  { name: "Very Low Tom (hit)", altName: "Floor Tom 2 - Hit" },
  { name: "Crash high (hit)", altName: "Crash 1 (Far Left) - Crash" },
  { name: "Crash high (choke)", altName: "Crash 1 (Far Left) - Choke" },
  { name: "Crash medium (hit)", altName: "Crash 2 (Left) - Crash" },
  { name: "Crash medium (choke)", altName: "Crash 2 (Left) - Choke" },
  { name: "Ride (edge)", altName: "Ride - Bow" },
  { name: "Ride (middle)", altName: "Ride - Bow" },
  { name: "Ride (bell)", altName: "Ride - Bell" },
  { name: "China (hit)", altName: "China - Crash" },
  { name: "China (choke)", altName: "China - Choke" },
  { name: "Splash (hit)", altName: "Splash - Crash" },
  { name: "Splash (choke)", altName: "Splash - Choke" },
];

/** MM2 and P5 share canonical articulation names; accept GTP names too. */
export const GGD_MM2_ALIASES: Alias[] = [
  ...GGD_P5_ALIASES,
  { name: "Ride (choke)", altName: "Ride - Choke" },
];
